<nz-modal
  [(nzVisible)]="isModalOpen"
  [nzFooter]="null"
  [nzClosable]="false"
  (nzOnCancel)="closeModal()"
  [nzWrapClassName]="'left-tab-modal'"
>
  <ng-container *nzModalContent>
    <div class="header">
      <span class="title">{{ title }}</span>
      <va-icon
        size="small"
        (click)="closeModal()"
        *ngIf="showClose"
        name="close"
      ></va-icon>
    </div>

    <!-- an optional secondary template to be added here if required -->

    <!-- Content Section -->
    <div class="divider"></div>

    <nz-tabset
      [nzTabPosition]="'left'"
      [nzType]="'line'"
      [nzTabBarGutter]="0"
      [(nzSelectedIndex)]="selectedTabIndex"
    >
      <nz-tab
        *ngFor="let tab of tabDetails; let idx = index"
        [nzTitle]="titleTemplate"
        [nzDisabled]="tab.header"
      >
        <ng-template #titleTemplate>
          <span *ngIf="!tab.header" class="tab-header-icon">
            <ng-container *ngTemplateOutlet="tab.svgIconTemplate"></ng-container>
            <va-icon
              isFontAwesome="true"
              *ngIf="tab.icon"
              [name]="tab.icon"
              class="tab-header-font-icon"
            ></va-icon>
          </span>
          {{ tab.title }}
        </ng-template>
        <ng-container *ngTemplateOutlet="tab.template"></ng-container>
      </nz-tab>
    </nz-tabset>

    <div class="divider"></div>
    <!-- button template  -->
    <ng-container *ngTemplateOutlet="btnTemplate"></ng-container>
  </ng-container>
</nz-modal>
